import SpecialtyType from './SpecialtyType'

const Specialty: { [key in SpecialtyType]: { text: string } } = {
  [SpecialtyType.Insurance]: { text: '保険' },
  [SpecialtyType.RealEstate]: { text: 'マンション経営' }
}

export default Specialty
